export default {
	$accessibility: {
		archived: "Archiviato",
		present: "Presente",
	},
	$accessModifier: {
		$description: {
			hidden_from_receiver: "Nascosto al destinatario",
			hidden_from_sender: "Nascosto al mittente",
			private: "Privato",
			shared_with_custom: "Condiviso con personalizzati",
			shared_with_everyone: "Condiviso con tutti",
			shared_with_receiver: "Condiviso con il destinatario",
			shared_with_sender: "Condiviso con il mittente",
		},
	},
	$antProduct: {
		limitGBStorage: "{limit}GB di archiviazione",
		limitMBStorage: "{limit}MB di archiviazione",
		limitUser: "{limit} Utente",
		limitUsers: "{limit} Utenti",
		renewAtPricePerUnit: "Si rinnoverà a {currency}{price} per {unit}",
		unlimitedModule: "{module} illimitato",
		upToLimitModule: "Fino a {limit} {module}",
	},
	$company: {
		address: "Kotekli Mah. Denizli Yolu Bul. Teknopark Sitesi B Blok No:4B Ic kapi No:14 MENTESE / MUGLA, TURCHIA",
		googleMapSrc:
			"https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d12715.523446137679!2d28.3731307!3d37.1793022!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14bf732687fd3eb1%3A0x2815d6eefcce8910!2sMu%C4%9Fla%20Teknopark!5e0!3m2!1sit!2str!4v1701805110461!5m2!1sit!2str",
		name: "Slush Software Inc.",
		phoneNumber: "+90 (555) 444-33-22",
		slogan:
			"Accelera la tua attività con Antrego. Gestisci i tuoi processi di spedizione digitalmente, in modo sicuro e semplice.",
	},
	$cookieBanner: {
		accept: "Accetta",
		decline: "Rifiuta",
		message:
			"Utilizziamo cookie e tecnologie simili per analisi e contenuti personalizzati. Cliccando su 'Accetta', acconsenti all'uso di queste tecnologie.",
	},
	$country: {
		afghanistan: "Afghanistan",
		aland: "Åland",
		albania: "Albania",
		algeria: "Algeria",
		american_samoa: "Samoa Americane",
		andorra: "Andorra",
		angola: "Angola",
		anguilla: "Anguilla",
		antarctica: "Antartide",
		antigua_and_barbuda: "Antigua e Barbuda",
		argentina: "Argentina",
		armenia: "Armenia",
		aruba: "Aruba",
		australia: "Australia",
		austria: "Austria",
		azerbaijan: "Azerbaijan",
		bahamas: "Bahamas",
		bahrain: "Bahrein",
		bangladesh: "Bangladesh",
		barbados: "Barbados",
		belarus: "Bielorussia",
		belgium: "Belgio",
		belize: "Belize",
		benin: "Benin",
		bermuda: "Bermuda",
		bhutan: "Bhutan",
		bolivia: "Bolivia",
		bonaire_sint_eustatius_and_saba: "Bonaire, Sint Eustatius e Saba",
		bosnia_and_herzegovina: "Bosnia ed Erzegovina",
		botswana: "Botswana",
		bouvet_island: "Isola Bouvet",
		brazil: "Brasile",
		british_indian_ocean_territory: "Territorio Britannico dell'Oceano Indiano",
		british_virgin_islands: "Isole Vergini Britanniche",
		brunei: "Brunei",
		bulgaria: "Bulgaria",
		burkina_faso: "Burkina Faso",
		burundi: "Burundi",
		cabo_verde: "Capo Verde",
		cambodia: "Cambogia",
		cameroon: "Camerun",
		canada: "Canada",
		cayman_islands: "Isole Cayman",
		central_african_republic: "Repubblica Centrafricana",
		chad: "Ciad",
		chile: "Cile",
		china: "Cina",
		christmas_island: "Isola di Natale",
		cocos_islands: "Isole Cocos [Keeling]",
		colombia: "Colombia",
		comoros: "Comore",
		congo_republic: "Repubblica del Congo",
		cook_islands: "Isole Cook",
		costa_rica: "Costa Rica",
		croatia: "Croazia",
		cuba: "Cuba",
		curacao: "Curaçao",
		cyprus: "Cipro",
		czechia: "Cechia",
		denmark: "Danimarca",
		djibouti: "Gibuti",
		dominica: "Dominica",
		dominican_republic: "Repubblica Dominicana",
		dr_congo: "Repubblica Democratica del Congo",
		ecuador: "Ecuador",
		egypt: "Egitto",
		el_salvador: "El Salvador",
		equatorial_guinea: "Guinea Equatoriale",
		eritrea: "Eritrea",
		estonia: "Estonia",
		eswatini: "Eswatini",
		ethiopia: "Etiopia",
		falkland_islands: "Isole Falkland",
		faroe_islands: "Isole Faroe",
		fiji: "Figi",
		finland: "Finlandia",
		france: "Francia",
		french_guiana: "Guyana Francese",
		french_polynesia: "Polinesia Francese",
		french_southern_territories: "Territori Francesi del Sud",
		gabon: "Gabon",
		gambia: "Gambia",
		georgia: "Georgia",
		germany: "Germania",
		ghana: "Ghana",
		gibraltar: "Gibilterra",
		greece: "Grecia",
		greenland: "Groenlandia",
		grenada: "Grenada",
		guadeloupe: "Guadalupa",
		guam: "Guam",
		guatemala: "Guatemala",
		guernsey: "Guernsey",
		guinea: "Guinea",
		guinea_bissau: "Guinea-Bissau",
		guyana: "Guyana",
		haiti: "Haiti",
		heard_island_and_mcdonald_islands: "Isole Heard e McDonald",
		honduras: "Honduras",
		hong_kong: "Hong Kong",
		hungary: "Ungheria",
		iceland: "Islanda",
		india: "India",
		indonesia: "Indonesia",
		iran: "Iran",
		iraq: "Iraq",
		ireland: "Irlanda",
		isle_of_man: "Isola di Man",
		israel: "Israele",
		italy: "Italia",
		ivory_coast: "Costa d'Avorio",
		jamaica: "Giamaica",
		japan: "Giappone",
		jersey: "Jersey",
		jordan: "Giordania",
		kazakhstan: "Kazakistan",
		kenya: "Kenya",
		kiribati: "Kiribati",
		kosovo: "Kosovo",
		kuwait: "Kuwait",
		kyrgyzstan: "Kirghizistan",
		laos: "Laos",
		latvia: "Lettonia",
		lebanon: "Libano",
		lesotho: "Lesotho",
		liberia: "Liberia",
		libya: "Libia",
		liechtenstein: "Liechtenstein",
		lithuania: "Lituania",
		luxembourg: "Lussemburgo",
		macao: "Macao",
		madagascar: "Madagascar",
		malawi: "Malawi",
		malaysia: "Malesia",
		maldives: "Maldive",
		mali: "Mali",
		malta: "Malta",
		marshall_islands: "Isole Marshall",
		martinique: "Martinica",
		mauritania: "Mauritania",
		mauritius: "Mauritius",
		mayotte: "Mayotte",
		mexico: "Messico",
		micronesia: "Micronesia",
		moldova: "Moldavia",
		monaco: "Monaco",
		mongolia: "Mongolia",
		montenegro: "Montenegro",
		montserrat: "Montserrat",
		morocco: "Marocco",
		mozambique: "Mozambico",
		myanmar: "Myanmar",
		namibia: "Namibia",
		nauru: "Nauru",
		nepal: "Nepal",
		netherlands: "Paesi Bassi",
		new_caledonia: "Nuova Caledonia",
		new_zealand: "Nuova Zelanda",
		nicaragua: "Nicaragua",
		niger: "Niger",
		nigeria: "Nigeria",
		niue: "Niue",
		norfolk_island: "Isola Norfolk",
		north_korea: "Corea del Nord",
		north_macedonia: "Macedonia del Nord",
		northern_mariana_islands: "Isole Marianne Settentrionali",
		norway: "Norvegia",
		oman: "Oman",
		pakistan: "Pakistan",
		palau: "Palau",
		palestine: "Palestina",
		panama: "Panama",
		papua_new_guinea: "Papua Nuova Guinea",
		paraguay: "Paraguay",
		peru: "Perù",
		philippines: "Filippine",
		pitcairn_islands: "Isole Pitcairn",
		poland: "Polonia",
		portugal: "Portogallo",
		puerto_rico: "Porto Rico",
		qatar: "Qatar",
		reunion: "Riunione",
		romania: "Romania",
		russia: "Russia",
		rwanda: "Ruanda",
		saint_barthelemy: "Saint Barthélemy",
		saint_helena: "Sant'Elena",
		saint_lucia: "Santa Lucia",
		saint_martin: "Saint Martin",
		saint_pierre_and_miquelon: "Saint Pierre e Miquelon",
		samoa: "Samoa",
		san_marino: "San Marino",
		sao_tome_and_principe: "São Tomé e Príncipe",
		saudi_arabia: "Arabia Saudita",
		senegal: "Senegal",
		serbia: "Serbia",
		seychelles: "Seychelles",
		sierra_leone: "Sierra Leone",
		singapore: "Singapore",
		sint_maarten: "Sint Maarten",
		slovakia: "Slovacchia",
		slovenia: "Slovenia",
		solomon_islands: "Isole Salomone",
		somalia: "Somalia",
		south_africa: "Sudafrica",
		south_georgia_and_south_sandwich_islands: "Georgia del Sud e Isole Sandwich Australi",
		south_korea: "Corea del Sud",
		south_sudan: "Sudan del Sud",
		spain: "Spagna",
		sri_lanka: "Sri Lanka",
		st_kitts_and_nevis: "Saint Kitts e Nevis",
		st_vincent_and_grenadines: "Saint Vincent e Grenadine",
		sudan: "Sudan",
		suriname: "Suriname",
		svalbard_and_jan_mayen: "Svalbard e Jan Mayen",
		sweden: "Svezia",
		switzerland: "Svizzera",
		syria: "Siria",
		taiwan: "Taiwan",
		tajikistan: "Tagikistan",
		tanzania: "Tanzania",
		thailand: "Thailandia",
		timor_leste: "Timor Est",
		togo: "Togo",
		tokelau: "Tokelau",
		tonga: "Tonga",
		trinidad_and_tobago: "Trinidad e Tobago",
		tunisia: "Tunisia",
		turkiye: "Turchia",
		turkmenistan: "Turkmenistan",
		turks_and_caicos_islands: "Isole Turks e Caicos",
		tuvalu: "Tuvalu",
		uganda: "Uganda",
		ukraine: "Ucraina",
		united_arab_emirates: "Emirati Arabi Uniti",
		united_kingdom: "Regno Unito",
		united_states: "Stati Uniti",
		uruguay: "Uruguay",
		us_minor_outlying_islands: "Isole Minori Esterne degli Stati Uniti",
		us_virgin_islands: "Isole Vergini Americane",
		uzbekistan: "Uzbekistan",
		vanuatu: "Vanuatu",
		vatican_city: "Città del Vaticano",
		venezuela: "Venezuela",
		vietnam: "Vietnam",
		wallis_and_futuna: "Wallis e Futuna",
		western_sahara: "Sahara Occidentale",
		yemen: "Yemen",
		zambia: "Zambia",
		zimbabwe: "Zimbabwe",
	},
	$currency: {
		euro: "Euro",
		turkish_lira: "Lira Turca",
		us_dollar: "Dollaro USA",
	},
	$documentManager: {
		message_1:
			'Per modificare il modello, fai clic sul pulsante "Modifica modello" per accedere alla schermata di modifica.',
		message_2: 'Puoi modificare il numero di righe nell\'elenco aumentando o diminuendo il "Numero di righe".',
		message_3:
			'Le modifiche apportate ai campi di contenuto verranno visualizzate immediatamente nella sezione "Anteprima".',
		message_4: 'Per generare un PDF, fai clic sul pulsante "Azioni documento" per salvarlo come PDF.',
		message_5: 'Per accedere ai documenti in seguito, puoi salvarli tramite il pulsante "Azioni documento".',
		message_6: "I dati inseriti in ogni cella della tabella verranno riflessi esattamente nell'anteprima.",
		message_7: "La tabella dati può essere modificata come un foglio Excel o un foglio elettronico.",
	},
	$employeeType: {
		admin: "Amministratore",
		default: "Predefinito",
		exporter: "Esportatore",
		importer: "Importatore",
	},
	$format: {
		date: "DD/MM/YYYY",
		date_time: "DD/MM/YYYY HH:mm:ss",
		date_time_without_second: "DD/MM/YYYY HH:mm",
	},
	$home: {
		$noCompany: {
			create_company_subtitle: "Crea la tua azienda qui.",
			create_company_title: "Vuoi aggiungere la tua azienda?",
			description: "Hai effettuato l'accesso con successo. Ora devi unirti a un'azienda o crearne una nuova.",
			join_company_subtitle: "Inserisci il tuo codice e unisciti all'azienda qui.",
			join_company_title: "Vuoi unirti a un'azienda esistente?",
			title: "Benvenuto {name}",
		},
		$unauthorized: {
			description: "Mantieni sotto controllo i tuoi processi di import-export con Antrego",
			forget_password_subtitle: "Inserisci la tua email per reimpostare la password.",
			sign_in_subtitle: "Accedi qui",
			sign_in_title: "Hai già un account?",
			sign_up_subtitle: "Registrati qui",
			sign_up_title: "Vuoi creare un account?",
			title: "Benvenuto in Antrego",
		},
	},
	$invitationType: {
		company_partner: "Invito per cooperazione commerciale",
		customs_partner: "Invito per partner doganale",
		employee: "Invito per dipendente",
	},
	$landing: {
		$benefits: {
			$detailPage: {
				hero_title: "Trasforma le operazioni della tua azienda",
				hero_subtitle: "Vantaggi della piattaforma",
				hero_description:
					"Scopri come Antrego semplifica l’intero flusso di lavoro logistico, dalla gestione dell’inventario al tracciamento delle spedizioni. Sperimenta maggiore efficienza, costi ridotti e collaborazione migliorata in tutta l’organizzazione.",
				features_title: "Vantaggi completi della piattaforma",
				feature_1_title: "Dashboard centralizzata",
				feature_1_desc:
					"Accedi a tutti i tuoi dati logistici—spedizioni, inventario e documenti—da un’unica interfaccia intuitiva.",
				feature_2_title: "Maggiore accuratezza dei dati",
				feature_2_desc:
					"Riduci gli errori con inserimento dati automatizzato, convalida e sincronizzazione in tempo reale tra tutti i moduli.",
				feature_3_title: "Efficienza nei tempi",
				feature_3_desc:
					"Risparmia ore ogni giorno con flussi di lavoro automatizzati, notifiche intelligenti e processi snelliti.",
				feature_4_title: "Collaborazione del team",
				feature_4_desc: "Abilita una collaborazione fluida tra team interni, clienti, fornitori e partner logistici.",
				feature_5_title: "Riduzione dei costi",
				feature_5_desc:
					"Riduci i costi operativi grazie a maggiore efficienza, meno errori e un’allocazione ottimizzata delle risorse.",
				feature_6_title: "Scalabilità",
				feature_6_desc:
					"Fai crescere la tua azienda con una piattaforma che si scala con facilità in base alle tue esigenze.",
				benefits_title: "Perché scegliere Antrego?",
				benefit_1: "Visibilità completa su tutta la catena di fornitura",
				benefit_2: "Piattaforma cloud sicura con crittografia di livello enterprise",
				benefit_3: "Design responsive per l’accesso in mobilità",
				benefit_4: "Notifiche automatiche che informano tutti gli stakeholder",
				benefit_5: "Flussi di lavoro personalizzabili che si adattano ai tuoi processi",
				benefit_6: "Team di supporto dedicato per garantire il tuo successo",
				workflow_title: "Come Antrego trasforma le tue operazioni",
				step_1_title: "Consolida le tue operazioni",
				step_1_desc:
					"Riunisci gestione dell’inventario, tracciamento spedizioni, gestione documenti e comunicazione con i clienti in un’unica piattaforma integrata.",
				step_2_title: "Automatizza le attività di routine",
				step_2_desc:
					"Lascia che Antrego gestisca attività ripetitive come inserimento dati, notifiche e aggiornamenti di stato, liberando il team per attività strategiche.",
				step_3_title: "Abilita la collaborazione in tempo reale",
				step_3_desc:
					"Condividi istantaneamente le informazioni con tutti gli stakeholder, assicurando che tutti abbiano accesso agli ultimi aggiornamenti e documenti.",
				step_4_title: "Prendi decisioni data-driven",
				step_4_desc:
					"Sfrutta analisi e report completi per individuare trend, ottimizzare i processi e promuovere il miglioramento continuo.",
				cta_title: "Pronto a trasformare le tue operazioni logistiche?",
				cta_button: "Inizia gratis oggi",
				cta_subtitle: "Nessuna carta di credito richiesta • Unisciti a oltre 500 aziende",
			},
			benefits_title: "Vantaggi della piattaforma",
			business_process: "Accelera i tuoi processi aziendali.",
			control_title: "Prendi il controllo con Antrego.",
			highlight_word: "controllo",
			risk_of_error: "Riduce il rischio di errori.",
			text: "Antrego trasforma le operazioni logistiche per esportatori, importatori, spedizionieri e produttori con soluzioni digitali end-to-end per la gestione dell'inventario, il tracciamento in tempo reale delle spedizioni e la documentazione automatizzata.",
			time_and_cost_savings: "Risparmia tempo e denaro.",
		},
		$content: {
			$text: {
				0: "Monitora tutte le tue spedizioni in un unico posto e controlla le tue finanze con report dinamici.",
				1: "Condividi i tuoi aggiornamenti in tempo reale con i tuoi clienti per migliorare la qualità del servizio.",
				2: "Visualizza e condividi tutti i documenti relativi alla tua spedizione in un unico sistema.",
				3: "Controlla facilmente il tuo processo accedendo ad Antrego da tutti i dispositivi e luoghi.",
				4: "Memorizza tutti i tuoi dati utilizzando la tecnologia di crittografia SHA-256. Resta sicuro riguardo alla sicurezza.",
				5: "Partecipa al monitoraggio congiunto con tutte le parti coinvolte nel processo aziendale. Gestisci il processo in modo più efficiente.",
			},
			$title: {
				0: "Gestione end-to-end delle spedizioni",
				1: "Comunicazione con i clienti in tempo reale",
				2: "Gestione documentale centralizzata",
				3: "Accesso cloud ovunque",
				4: "Sicurezza di livello enterprise",
				5: "Collaborazione multi-parte",
			},
			content_title: "Tutto ciò di cui hai bisogno in un’unica piattaforma",
		},
		$home: {
			subtitle: "Gestisci inventario, spedizioni, documenti e tracciamento in un’unica piattaforma potente",
			text: "Risparmia il 40% del tempo operativo con flussi di lavoro automatizzati. Unisciti a oltre 500 aziende che ottimizzano le loro operazioni logistiche a livello globale.",
			title: "Piattaforma logistica completa: dallo stock alla consegna",
		},
		$lifecycle: {
			headline: "Processo",
			info_button: "Ottieni informazioni",
			lifecycle_texts: {
				0: "Carica file aggiuntivi per creare la tua fattura proforma e condividila immediatamente con il tuo cliente.",
				1: "Inserisci i dettagli della spedizione e aggiungi documenti. Notifica al tuo cliente e gestisci congiuntamente tutti i processi di spedizione attraverso un unico canale.",
				2: "Monitora la tua situazione finanziaria relativa all'importazione ed esportazione in tempo reale.",
			},
			lifecycle_titles: {
				0: "Accedi e crea la fattura proforma",
				1: "Crea spedizione",
				2: "Monitora le attività finanziarie",
			},
			productivity_title: "Aumenta la produttività e riduci la complessità e gli errori in 3 passaggi.",
			tracking_guide_title: "Guida al tracciamento facile",
		},
		$logistics: {
			logistics_title: "Tipi di logistica supportati",
			solutions_title: "La soluzione giusta per ogni carico",
			text: "Con Antrego, il tuo partner digitale in tutti i tipi di trasporto, siamo al tuo fianco per tutti i tuoi movimenti globali.",
		},
		$pdfEditor: {
			$detailPage: {
				hero_title: "Creazione professionale di documenti PDF",
				hero_subtitle: "Crea documenti commerciali straordinari in pochi minuti",
				hero_description:
					"Il creatore PDF intuitivo di Antrego ti consente di progettare, personalizzare e generare facilmente fatture, proforma e documenti commerciali professionali. Nessuna competenza di design richiesta.",
				features_title: "Tutto ciò che ti serve per creare documenti professionali",
				feature_1_title: "Editor drag & drop",
				feature_1_desc:
					"Un’interfaccia intuitiva ti permette di aggiungere testo, immagini, loghi e tabelle con semplici azioni di trascinamento. Nessuna competenza tecnica necessaria.",
				feature_2_title: "Modelli personalizzati",
				feature_2_desc:
					"Scegli tra modelli predefiniti o crea layout con il tuo brand. Salva i modelli per garantire coerenza nel branding.",
				feature_3_title: "Campi modulo intelligenti",
				feature_3_desc:
					"Popola automaticamente informazioni del cliente, dettagli dei prodotti e prezzi. Connetti direttamente dati di spedizioni e stock.",
				feature_4_title: "Personalizzazione del brand",
				feature_4_desc:
					"Aggiungi il logo aziendale, scegli colori e caratteri del brand e crea documenti che rappresentano al meglio la tua identità.",
				feature_5_title: "Esportazione multi-formato",
				feature_5_desc:
					"Scarica in PDF, stampa direttamente o condividi via email. Tutti i documenti sono formattati professionalmente e pronti per la stampa.",
				feature_6_title: "Controllo versione",
				feature_6_desc:
					"Tieni traccia delle revisioni dei documenti, mantieni lo storico e accedi alle versioni precedenti. Non perderai più iterazioni importanti.",
				benefits_title: "Perché scegliere il creatore PDF di Antrego?",
				benefit_1: "Crea documenti professionali 10 volte più velocemente rispetto ai metodi tradizionali",
				benefit_2: "Mantieni un branding coerente su tutti i documenti commerciali",
				benefit_3: "Riduci gli errori grazie alla compilazione automatica dai dati delle spedizioni",
				benefit_4: "Risparmia tempo con modelli riutilizzabili e moduli intelligenti",
				benefit_5: "Impressiona i clienti con documenti rifiniti e professionali",
				benefit_6: "Accedi ai tuoi documenti ovunque e in qualsiasi momento da qualsiasi dispositivo",
				workflow_title: "Come funziona la creazione PDF",
				step_1_title: "Scegli il modello",
				step_1_desc: "Seleziona tra modelli predefiniti o parti da zero per creare il tuo layout personalizzato.",
				step_2_title: "Personalizza i contenuti",
				step_2_desc:
					"Trascina gli elementi, aggiungi logo e branding, compila automaticamente i campi con i dati di spedizione.",
				step_3_title: "Anteprima e modifica",
				step_3_desc:
					"Rivedi il documento in tempo reale, apporta modifiche e assicurati che tutto sia perfetto prima della generazione.",
				step_4_title: "Genera e condividi",
				step_4_desc:
					"Scarica in PDF, invia direttamente ai clienti via email o allega alle spedizioni. Salva il modello per usi futuri.",
				cta_title: "Inizia oggi a creare documenti professionali",
				cta_button: "Inizia gratis",
				cta_subtitle: "Nessuna carta di credito richiesta • Inizia in pochi minuti",
			},
			description:
				"Il nostro editor PDF è uno strumento potente che rende la creazione e modifica delle fatture più pratica. Risparmia tempo e presenta documenti dall'aspetto professionale ai tuoi partner commerciali.",
			features: {
				design:
					"Progettazione delle fatture: Aggiungi il tuo logo, regola i colori e personalizza il formato della fattura.",
				edit: "Modifica documenti: Modifica rapidamente i PDF, aggiungi o rimuovi testo.",
				shareSave:
					"Condivisione e salvataggio: Scarica, condividi o archivia i documenti creati direttamente sulla piattaforma.",
			},
			longTitle: "Fatture rapide e personalizzate con l'editor PDF.",
			note: "Questa configurazione consente agli utenti di esplorare visivamente le funzionalità e di esaminare i vantaggi per iscritto.",
			title: "Creare fatture è così facile!",
		},
		$process: {
			comparison_subtitle: "Vedi la differenza tra gestione logistica tradizionale e digitale",
			digital_future: "Allontanati dai metodi tradizionali e fai un passo nel futuro digitale",
			digital_shipping: "Monitoraggio digitale delle spedizioni con Antrego",
			digital_shipping_texts: {
				0: "Le fatture proforma per gli ordini in arrivo vengono create e monitorate facilmente attraverso un unico canale.",
				1: "Le fatture proforma vengono inviate, le notifiche vengono inviate immediatamente al cliente e vengono approvate tramite Antrego.",
				2: "I processi documentali sono gestiti tramite Antrego. Non vengono persi, non ci sono ritardi e il potenziale di errore è minimizzato.",
				3: "Fornitori, clienti e broker doganali possono visualizzare immediatamente i dettagli della spedizione e monitorarli congiuntamente.",
				4: "I report finanziari vengono generati automaticamente su base mensile e annuale.",
			},
			question_title: "Come Antrego ti fa risparmiare 10+ ore a settimana",
			tracking_method: "Digitalizza i tuoi metodi di tracciamento e accelera i tuoi processi.",
			traditional_shipping: "Monitoraggio delle spedizioni tradizionale",
			traditional_shipping_texts: {
				0: "Gli ordini vengono raccolti tramite e-mail, messaggi o telefono attraverso diversi canali, causando difficoltà nel monitoraggio interno.",
				1: "La fattura proforma viene creata utilizzando strumenti come Excel e il processo di approvazione viene gestito manualmente tramite e-mail, WhatsApp o telefono.",
				2: "I processi manuali dei documenti portano a errori e ritardi, causando perdite di tempo e denaro.",
				3: "Non esiste una piattaforma comune per fornitori, clienti e broker doganali per monitorare i dettagli della spedizione.",
				4: "I dati finanziari vengono verificati individualmente dopo ogni spedizione, rendendo difficoltosa la creazione di report.",
			},
		},
		$question: {
			$text: {
				0: "<p>Antrego è una piattaforma completa di gestione logistica che aiuta le aziende a tracciare le spedizioni, gestire l’inventario e collaborare con i clienti in tempo reale. Digitalizza l’intero processo della supply chain dallo stock alla consegna.</p>",
				1: "<p>Antrego semplifica la logistica con Accesso semplice da qualsiasi dispositivo, Sicurezza dei dati di livello enterprise tramite crittografia SHA-256 e Tracciamento congiunto che mantiene informati tutti gli stakeholder durante l’intero processo di spedizione.</p>",
				2: "<p>Antrego supporta tutte le principali modalità di trasporto, tra cui trasporto marittimo, cargo aereo, trasporto terrestre e logistica ferroviaria. Collaboriamo con tutti i principali vettori e compagnie di navigazione nel mondo.</p>",
				3: "<p>Antrego offre un piano gratuito fino a 10 spedizioni al mese senza carta di credito. I piani Premium partono da 99 $/mese per spedizioni illimitate, con fatturazione annuale che consente un risparmio del 16%. Consulta la nostra pagina dei prezzi per i dettagli completi.</p>",
				4: "<p>Stiamo sviluppando l’accesso alle API e le capacità di integrazione con i principali sistemi logistici ed ERP. Le funzioni di integrazione sono previste per le prossime release. Contattaci per saperne di più sulla roadmap e sulle funzionalità in arrivo.</p>",
				5: "<p>La maggior parte delle aziende è operativa entro 24 ore. La configurazione di base richiede solo 5-10 minuti per creare l’account e aggiungere le informazioni aziendali. Il nostro team di onboarding ti aiuta a importare i dati e personalizzare i flussi di lavoro.</p>",
			},
			$title: {
				0: "Che cos’è Antrego?",
				1: "Perché dovrei usare Antrego?",
				2: "Quali tipi di logistica supporta Antrego?",
				3: "Quanto costa Antrego?",
				4: "Posso integrare Antrego con i miei sistemi esistenti?",
				5: "Quanto tempo serve per configurare Antrego?",
			},
			save_percentage: "Risparmia il 16% al mese",
			text: "Accedi facilmente a tutte le informazioni con Antrego e contattaci per qualsiasi altra domanda.",
			title: "Impara rapidamente tutto ciò che ti incuriosisce",
		},
		$stockFeature: {
			$detailPage: {
				hero_title: "Trasforma la gestione dello stock",
				hero_subtitle: "Dall’inventario alle vendite: gestisci digitalmente l’intero ciclo di vita del prodotto",
				hero_description:
					"La funzione di Gestione scorte di Antrego consente a esportatori e produttori di gestire in modo efficiente l’inventario, condividere cataloghi prodotti con i clienti e accelerare il processo di vendita in un’unica piattaforma integrata.",
				features_title: "Potenti funzionalità per la gestione delle scorte",
				feature_1_title: "Gestione centralizzata dell’inventario",
				feature_1_desc:
					"Gestisci tutti gli articoli di magazzino da un’unica dashboard. Traccia quantità, numeri di lotto, magazzini e dettagli dei prodotti con facilità.",
				feature_2_title: "Catalogo pubblico delle scorte",
				feature_2_desc:
					"Crea una pagina catalogo pubblica per mostrare i prodotti disponibili ai potenziali clienti in tutto il mondo. Condividi il tuo inventario con un semplice link.",
				feature_3_title: "Tracciamento dei lotti",
				feature_3_desc:
					"Traccia singoli lotti con informazioni dettagliate tra cui quantità, dimensioni e attributi personalizzati per una gestione precisa dell’inventario.",
				feature_4_title: "Supporto multi-magazzino",
				feature_4_desc:
					"Organizza l’inventario su più magazzini e sedi. Tieni traccia di dove è conservato ogni prodotto per una logistica efficiente.",
				feature_5_title: "Galleria immagini prodotto",
				feature_5_desc:
					"Carica più immagini per ogni articolo di stock per offrire chiarezza visiva ai clienti e ai membri del team.",
				feature_6_title: "Conversione diretta in spedizione",
				feature_6_desc:
					"Converti senza soluzione di continuità gli articoli di stock in spedizioni. Crea proforma e documenti di spedizione direttamente dall’inventario.",
				benefits_title: "Perché scegliere Antrego per la gestione delle scorte?",
				benefit_1: "Aumenta la visibilità dei tuoi prodotti verso acquirenti globali",
				benefit_2: "Riduci il tempo speso nel tracciamento manuale dell’inventario",
				benefit_3: "Snellisci il passaggio dallo stock alle vendite",
				benefit_4: "Fornisci informazioni di stock in tempo reale ai clienti",
				benefit_5: "Supporto per oltre 15 lingue per raggiungere i mercati internazionali",
				benefit_6: "Integrazione con sistemi di spedizione e fatturazione",
				workflow_title: "Come funziona",
				step_1_title: "Aggiungi i tuoi prodotti",
				step_1_desc:
					"Crea articoli di stock con dettagli completi inclusi dettagli prodotto, quantità, magazzini e immagini.",
				step_2_title: "Condividi il tuo catalogo",
				step_2_desc:
					"Genera un link pubblico al tuo catalogo delle scorte che i potenziali clienti possono visualizzare e consultare in qualsiasi momento.",
				step_3_title: "Ricevi richieste",
				step_3_desc:
					"I clienti possono visualizzare i prodotti disponibili e contattarti direttamente per ordini e preventivi.",
				step_4_title: "Converti in vendite",
				step_4_desc:
					"Crea facilmente proforma e spedizioni dagli articoli di stock per evadere gli ordini dei clienti.",
				cta_title: "Pronto a modernizzare la gestione dell’inventario?",
				cta_button: "Inizia gratis",
				cta_subtitle: "Nessuna carta di credito richiesta • Configurazione in pochi minuti",
			},
			access_potential_customers: "Accedi rapidamente ai clienti potenziali",
			desc: "Antrego è stato progettato appositamente per esportatori e produttori, accelerando i processi di vendita e marketing. Fai crescere la tua attività con la gestione delle scorte, la condivisione delle scorte con i clienti e la gestione delle spedizioni!",
			global_market: "Affermati nel mercato globale con il supporto di 15 lingue diverse",
			main_title: "La soluzione di nuova generazione per vendite e marketing",
			manage_stocks: "Gestisci e condividi le tue scorte immediatamente",
			speed_up_sales: "Accelera i processi di vendita",
			title: "Dallo Stock alla Vendita",
		},
		$tracking: {
			$detailPage: {
				hero_title: "Tracciamento delle spedizioni in tempo reale",
				hero_subtitle: "Monitora ogni container, in ogni fase",
				hero_description:
					"Il sistema di tracciamento avanzato di Antrego offre visibilità completa sulle spedizioni con aggiornamenti in tempo reale, notifiche automatiche e report di stato completi. Non perdere mai di vista i tuoi container.",
				features_title: "Soluzione di tracciamento completa",
				feature_1_title: "Tracciamento live dei container",
				feature_1_desc:
					"Traccia i container in tempo reale con posizione precisa e tempi di arrivo stimati per ogni spedizione.",
				feature_2_title: "Notifiche automatizzate",
				feature_2_desc:
					"Ricevi avvisi immediati per le tappe importanti: carico, partenza, arrivo, sdoganamento e stato di consegna.",
				feature_3_title: "Storico degli stati",
				feature_3_desc:
					"Accedi alla cronologia completa della spedizione con registri dettagliati di movimenti, cambi di stato ed eventi chiave.",
				feature_4_title: "Visibilità multi-stakeholder",
				feature_4_desc:
					"Condividi le informazioni di tracciamento con clienti, fornitori e spedizionieri doganali. Tutti restano informati automaticamente.",
				feature_5_title: "Gestione documentale",
				feature_5_desc:
					"Allega e accedi a tutti i documenti di spedizione, inclusi polizze di carico, moduli doganali e certificati, in un unico luogo.",
				feature_6_title: "Avvisi di ritardo",
				feature_6_desc:
					"Ricevi notifiche proattive su potenziali ritardi o problemi così da intervenire prima che peggiorino.",
				benefits_title: "Perché scegliere il tracciamento di Antrego?",
				benefit_1: "Riduci le richieste dei clienti con pagine di tracciamento self-service",
				benefit_2: "Previeni costosi ritardi con monitoraggio proattivo e avvisi",
				benefit_3: "Migliora la soddisfazione del cliente con comunicazione trasparente",
				benefit_4: "Risparmia tempo con aggiornamenti di stato automatici per tutti gli stakeholder",
				benefit_5: "Riduci i rischi con visibilità in tempo reale sullo stato delle spedizioni",
				benefit_6: "Pagine di tracciamento professionali che valorizzano il tuo brand",
				workflow_title: "Come funziona il tracciamento",
				step_1_title: "Crea la spedizione",
				step_1_desc:
					"Inserisci nel sistema i dettagli della spedizione, inclusi numeri dei container, rotte e date previste.",
				step_2_title: "Aggiornamenti automatici",
				step_2_desc:
					"Il sistema traccia automaticamente i container e aggiorna lo stato man mano che passano i checkpoint.",
				step_3_title: "Notifiche agli stakeholder",
				step_3_desc: "Tutte le parti ricevono notifiche istantanee sulle tappe importanti e sui cambi di stato.",
				step_4_title: "Conferma di consegna",
				step_4_desc: "Ottieni conferma finale della consegna con documentazione completa e storico della spedizione.",
				cta_title: "Inizia a tracciare le spedizioni con fiducia",
				cta_button: "Inizia gratis",
				cta_subtitle: "Nessuna carta di credito richiesta • Inizia a tracciare oggi",
			},
			control_title: "Prendi il controllo delle tue spedizioni con Antrego.",
			real_time_alerts:
				"Avvisi in tempo reale: Ricevi notifiche istantanee e aggiornamenti completi sullo stato di ogni container.",
			secure_data_handling:
				"Gestione sicura dei dati: Scarica, condividi o archivia facilmente i dati delle tue spedizioni direttamente sulla piattaforma.",
			tracking_description:
				"La soluzione di tracciamento container di Antrego offre un modo rapido ed efficiente per monitorare le tue spedizioni in tempo reale. Rimani in controllo e impressiona i tuoi partner con aggiornamenti dettagliati e professionali.",
			tracking_title: "Traccia le tue spedizioni con facilità!",
		},
		cancel_anytime: "Annulla in qualsiasi momento",
		customize_package:
			"Puoi acquistare spazio di archiviazione e utenti aggiuntivi e personalizzare il tuo pacchetto in base alle tue esigenze",
		free_features_1: "10 Spedizioni",
		free_features_2: "100 MB di archiviazione",
		free_features_3: "Partner commerciali illimitati",
		free_features_4: "1 Utente",
		free_plan: "Gratuito",
		free_price: "€0",
		free_regeneration: "",
		free_title: "Mensile",
		premium_annual_features_1: "20 Utenti",
		premium_annual_features_2: "100 Partner",
		premium_annual_features_3: "1000 Spedizioni",
		premium_annual_features_4: "1000 Fatture",
		premium_annual_price: "€83.25",
		premium_annual_regeneration: "Si rinnoverà annualmente a €999",
		premium_annual_title: "Annuale",
		premium_monthly_features_1: "Spedizioni illimitate",
		premium_monthly_features_2: "Partner commerciali illimitati",
		premium_monthly_features_3: "2GB di archiviazione",
		premium_monthly_features_4: "3 Utenti",
		premium_monthly_price: "€99",
		premium_monthly_regeneration: "Si rinnoverà mensilmente a €99",
		premium_monthly_title: "Mensile",
		premium_plan: "Piano Premium",
		premium_plus_annual_features_1: "Spedizioni illimitate",
		premium_plus_annual_features_2: "Partner commerciali illimitati",
		premium_plus_annual_features_3: "5GB di archiviazione",
		premium_plus_annual_features_4: "5 Utenti",
		premium_plus_annual_price: "€83.25",
		premium_plus_annual_regeneration: "Si rinnoverà annualmente a €999",
		premium_plus_annual_title: "Annuale",
		premium_plus_monthly_features_1: "Spedizioni illimitate",
		premium_plus_monthly_features_2: "Partner commerciali illimitati",
		premium_plus_monthly_features_3: "5GB di archiviazione",
		premium_plus_monthly_features_4: "5 Utenti",
		premium_plus_monthly_price: "€249",
		premium_plus_monthly_regeneration: "Si rinnoverà mensilmente a €249",
		premium_plus_monthly_title: "Mensile",
		premium_plus_plan: "Premium Plus",
		pricing_text: "Possiamo soddisfare le tue esigenze nel modo migliore senza superare il tuo budget.",
		pricing_title: "Antrego garantisce di offrire il miglior pacchetto e prezzo per te.",
		save_percentage: "Risparmia il 16% al mese",
	},
	$language: {
		ar: "العربية",
		de: "Deutsch",
		en: "English",
		es: "Español",
		fr: "Français",
		hi: "हिन्दी",
		ind: "Bahasa Indonesia",
		it: "Italiano",
		ja: "日本語",
		ko: "한국어",
		pt: "Português",
		ru: "Русский",
		tr: "Türkçe",
		vi: "Tiếng Việt",
		zh: "中文",
	},
	$languageLocal: {
		ar: "Arabo",
		de: "Tedesco",
		en: "Inglese",
		es: "Spagnolo",
		fr: "Francese",
		hi: "Hindi",
		ind: "Indonesiano",
		it: "Italiano",
		ja: "Giapponese",
		ko: "Coreano",
		pt: "Portoghese",
		ru: "Russo",
		tr: "Turco",
		vi: "Vietnamita",
		zh: "Cinese",
	},
	$message: {
		cannot_delete_verified_partner: "Non puoi eliminare un partner verificato.",
		confirm: "Sei sicuro di {function}?",
		created: "{item} creato.",
		deleted: "{item} eliminato.",
		edited: "{item} modificato.",
		error_on_view_file: "Si è verificato un errore durante la visualizzazione del file.",
		file_oversize: "La dimensione del file deve essere massimo {size}.",
		invalid: "{item} non valido",
		migrated: "{item} migrato. ({value})",
		process_has_been_started: "Il tuo {item} è stato avviato.",
		saved: "{item} salvato.",
		sent: "{item} inviato.",
		sent_email: "E-mail inviata. ({value})",
		sign_in_failed: "E-mail o password non corretta",
		unsupported_file_type: "Tipo di file non supportato",
		updated: "{item} aggiornato.",
	},
	$pageDescriptions: {
		landing_page:
			"Antrego - Piattaforma completa di gestione logistica per esportatori, importatori e spedizionieri. Traccia spedizioni in tempo reale, gestisci l’inventario, crea fatture e automatizza la documentazione. Risparmia il 40% del tempo con soluzioni logistiche digitali. Provala gratis!",
		stock_feature:
			"Trasforma la gestione dello stock con Antrego. Gestisci l’inventario, crea cataloghi pubblici, traccia i lotti tra i magazzini e converti lo stock in spedizioni all’istante. Perfetto per esportatori e produttori.",
		tracking_feature:
			"Tracciamento container e spedizioni in tempo reale con Antrego. Monitora ogni container con aggiornamenti live, notifiche automatiche, storico completo degli stati e visibilità multi-stakeholder. Non perdere mai il controllo delle spedizioni.",
		pdf_feature:
			"Creatore di documenti PDF professionali per la logistica. Progetta fatture e proforma personalizzate con editor drag-and-drop, modelli e compilazione dati automatica. Crea documenti straordinari in pochi minuti.",
		benefits_feature:
			"Scopri i vantaggi della piattaforma Antrego. Dashboard centralizzata, maggiore accuratezza, efficienza, collaborazione del team, riduzione dei costi e scalabilità. Trasforma oggi le tue operazioni logistiche.",
		contact:
			"Contatta Antrego - Mettiti in contatto con il nostro team per domande, demo o supporto. Siamo qui per aiutarti a trasformare le tue operazioni logistiche.",
		sign_in:
			"Accedi ad Antrego - Entra nella dashboard logistica per gestire spedizioni, tracciare container, creare fatture e collaborare con il tuo team. Portale di accesso sicuro.",
		sign_up:
			"Registrati ad Antrego - Crea il tuo account gratuito per iniziare a gestire le operazioni logistiche. Ottieni 10 spedizioni gratuite al mese. Nessuna carta di credito richiesta.",
	},
	$pageTitles: {
		accept_invitation: "Accetta invito",
		benefits_feature: "Vantaggi della piattaforma - Soluzione logistica completa",
		company_profile: "Profilo aziendale",
		contact: "Contattaci - Mettiti in contatto con Antrego",
		home: "Home",
		landing_page: "Gestisci facilmente tutti i tuoi processi di spedizione digitalmente",
		partners: "Partner",
		pdf_editor: "Editor PDF",
		pdf_feature: "Creatore di documenti PDF - Fatture professionali",
		product_details: "Dettagli del Prodotto",
		product_groups: "Gruppi di prodotti",
		products: "Prodotti",
		proforma_invoices: "Fatture proforma",
		shipment_details: "Dettagli della spedizione",
		shipments: "Spedizioni",
		sign_in: "Accedi",
		sign_up: "Registrati",
		stock_details: "Dettagli della Scorta",
		stock_feature: "Gestione scorte - Trasforma il tuo inventario",
		stocks: "Scorte",
		subscription: "Abbonamento",
		tracking_feature: "Tracciamento spedizioni - Monitoraggio container in tempo reale",
		user_profile: "Profilo utente",
	},
	$partnershipStatusTooltip: {
		createdHereDescription:
			"Partner non registrati, hai creato il loro profilo sulla nostra piattaforma, quindi puoi visualizzare e modificare le loro informazioni.",
		createdHereTitle: "Creato qui:",
		description: "Puoi monitorare lo stato della tua relazione con i tuoi partner. Ecco le differenze:",
		verifiedPartnersDescription:
			"Questi partner hanno accettato il tuo invito e si sono registrati sulla piattaforma. Le loro informazioni sono solo visualizzabili e non possono essere modificate.",
		verifiedPartnersTitle: "Partner verificati:",
	},
	$productGroup: {
		add_child: "Aggiungi figlio",
		add_new_product_group: "Aggiungi nuovo gruppo di prodotti",
		add_to_root: "Aggiungi alla radice",
		has_children_fail_message: "Un gruppo di prodotti con un figlio non può essere eliminato",
		initial_message: "Usa questo {0} pulsante per creare il tuo primo gruppo di prodotti.",
		name: "Nome",
		number_of_product: "Numero di prodotti",
	},
	$proformaInvoice: {
		$actionDescription: {
			approve: "{name} approvato.",
			create: "Creato da {name}.",
			create_attachment: "{name} ha creato un allegato.",
			delete_attachment: "{name} ha eliminato un allegato.",
			demand_revise: "{name} ha richiesto una revisione.",
			mark_as_processed: "{name} contrassegnato come elaborato.",
			reject: "{name} respinto.",
			revoke: "{name} revocato.",
			send: "{name} inviato al destinatario per la valutazione.",
			update: "Aggiornato da {name}.",
			update_attachment: "{name} ha aggiornato un allegato.",
		},
		$actions: {
			approve: "Approva",
			demand_revise: "Richiedi revisione",
			mark_as_approved: "Approvato",
			mark_as_processed: "Elaborato",
			mark_as_rejected: "Respinto",
			mark_as_revise_demanded: "Revisione richiesta",
			mark_as_revoked: "Revocato",
			mark_as_sent: "Inviato",
			reject: "Respingi",
			revoke: "Revoca",
			send: "Invia",
		},
		$status: {
			approved: "Approvato",
			pending_approval: "In attesa di approvazione",
			pending_revise: "In attesa di revisione",
			processed: "Elaborato",
			rejected: "Respinto",
			revoked: "Revocato",
			template: "Modello",
		},
		approve_confirm_message: "Sei sicuro di approvare la fattura proforma?",
		approve_success_message: "La fattura proforma è stata approvata.",
		demand_revise_description_message: "Per favore, fornisci qualche dettaglio sulla tua aspettativa di revisione:",
		demand_revise_success_message: "La fattura proforma è stata inviata al mittente per la revisione.",
		mark_as_processed_confirm_message: "Confermi di contrassegnare la fattura proforma come elaborata?",
		mark_as_processed_success_message: "La fattura proforma è stata contrassegnata come elaborata.",
		no_attachment_text: "Nessun allegato aggiunto ancora.",
		reject_confirm_message: "Sei sicuro di respingere la fattura proforma?",
		reject_success_message: "La fattura proforma è stata respinta.",
		revoke_confirm_message: "Sei sicuro di revocare la fattura proforma?",
		revoke_success_message: "La fattura proforma è stata revocata.",
		send_confirm_message: "Confermi di inviare la fattura proforma al destinatario?",
		send_success_message: "La fattura proforma è stata inviata.",
	},
	$seoTitles: {
		landing_page: "Antrego | Software di gestione logistica - Traccia, Gestisci, Automatizza",
		stock_feature: "Software di gestione dell'inventario | Sistema di tracciamento delle scorte | Antrego",
		tracking_feature: "Software di tracciamento spedizioni in tempo reale | Tracciamento container | Antrego",
		pdf_feature: "Generatore di fatture proforma | Editor PDF per la logistica | Antrego",
		benefits_feature: "Vantaggi di una piattaforma logistica completa | Soluzione all-in-one | Antrego",
	},
	$serviceMessage: {
		already_subs_module: "C'è già un abbonamento per questo modulo.",
		bad_request: "Richiesta errata",
		code_already_used: "Codice già utilizzato.",
		container_status_not_available: "Stato del container non disponibile.",
		existing_email_warning: "E-mail già esistente.",
		existing_employee_error: "Questo utente è già stato aggiunto alla tua azienda.",
		existing_employee_for_email_warning: "Il codice di invito è già stato inviato a questa e-mail",
		existing_invitation_warning: "Il codice di invito è già stato inviato a questa e-mail.",
		existing_token_already_have_time: "Il token esistente ha già tempo sufficiente per essere utilizzato.",
		existing_user: "L'utente esiste già.",
		five_min_reset_password_mail:
			"Devi attendere almeno 5 minuti dopo aver richiesto un'e-mail di reimpostazione della password una volta.",
		forbidden: "Proibito",
		have_no_corporation: "Non hai una società",
		have_no_custom_agency: "Non hai un'agenzia doganale",
		have_no_employee: "Non hai dipendenti",
		instance_can_no_delete_existing_booking_code:
			"L'istanza non può più essere eliminata a causa del codice di prenotazione esistente.",
		instance_cannot_delete: "L'istanza non può più essere eliminata.",
		instance_not_found: "Istanza non trovata.",
		internal_server_error: "Errore interno del server",
		invalid_current_password: "Password attuale non valida.",
		invalid_identifier_or_password: "Identificatore o password non validi",
		invalid_invitation_code: "Il codice di invito è errato.",
		invalid_moving_request: "Richiesta di spostamento non valida",
		invalid_operation: "Operazione non valida",
		invalid_refresh_token: "Token di aggiornamento non valido.",
		invalid_unit: "Unità non valida",
		invitation_accepting_is_due_to_the_admin: "L'accettazione dell'invito è dovuta all'amministratore.",
		invitation_already_discarded: "L'invito è già stato scartato.",
		invitation_already_used: "L'invito è già stato utilizzato.",
		invitation_has_been_used: "L'invito è stato utilizzato.",
		invitation_not_exist_email: "L'invito non esiste indirizzo e-mail.",
		invitation_not_for_company: "Questo invito non è per un'azienda.",
		invitation_not_for_custom_agency: "Questo invito non è per un'agenzia doganale.",
		invitation_not_found: "L'invito non è stato trovato.",
		invitation_not_valid: "L'invito non è più valido.",
		link_has_been_expired: "Il link è scaduto.",
		link_not_be_used_anymore: "Questo link non può più essere utilizzato",
		missing_required_fields: "Campi obbligatori mancanti.",
		no_employee_found: "Nessun dipendente trovato",
		no_proper_partner_found: "Nessun partner appropriato trovato.",
		not_acceptable: "Non accettabile",
		not_allowed_action: "Non ti è permesso compiere questa azione.",
		not_allowed_use_api: "Non sei autorizzato a utilizzare questa API.",
		not_found: "Non trovato",
		not_have_purchase_subscription:
			"Il tuo piano di abbonamento ha raggiunto il limite massimo di definizioni. Per aggiungere altre, considera l'upgrade del tuo piano di abbonamento.",
		not_permitted_use_api: "Non sei autorizzato a utilizzare questa API.",
		own_invitation_cannot_accept: "Non puoi accettare il tuo stesso invito.",
		parent_group_not_found: "Gruppo padre non trovato",
		partnerId_required: "ID partner richiesto.",
		partnership_already_exists: "Il partner è già stato aggiunto.",
		password_cant_involve_space_char: "La password non può contenere spazi.",
		password_min_chars_least: "La password deve contenere almeno 6 caratteri.",
		payment_required: "Abbonati per questo processo.",
		paytr_integration_error: "Errore nell'integrazione PayTR",
		ports_are_required: "Sono richiesti i porti.",
		product_group_tree_not_found: "Albero del gruppo di prodotti non trovato",
		proforma_invoice_action_not_available: "Lo stato della fattura proforma non è disponibile per questa azione.",
		proforma_invoice_template_update: "La fattura proforma deve essere un modello per essere aggiornata.",
		shipment_email_not_exist: "Inserisci un'e-mail valida.",
		shipment_method_is_required: "È richiesto il metodo di spedizione.",
		shipping_term_is_required: "È richiesto il termine di spedizione.",
		someone_else_uses_this_email: "Qualcun altro utilizza questo indirizzo e-mail.",
		someone_else_uses_this_username: "Qualcun altro utilizza questo nome utente.",
		something_went_wrong: "Qualcosa è andato storto",
		type_can_be_abstract_company: '"tipo" può essere solo "società astratta"',
		unauthorized: "Non autorizzato",
		undefined_result: "Risultato non definito",
		unexpected_error_occurred: "Si è verificato un errore imprevisto",
		unit_already_added: "L'unità è già stata aggiunta.",
		user_already_employee: "L'utente è già un dipendente.",
		user_already_exists: "L'utente esiste già in un'azienda.",
		user_does_not_exist: "L'utente non esiste.",
		user_not_found: "Utente non trovato.",
		username_min_chars_error: '"username" deve contenere almeno 6 caratteri.',
	},
	$shipment: {
		$actionDescription: {
			$land: {
				create_container: "{name} ha aggiunto un veicolo.",
				delete_container: "{name} ha eliminato un veicolo.",
				update_container: "{name} ha aggiornato un veicolo.",
			},
			create: "Creato da {name}.",
			create_attachment: "{name} ha aggiunto un allegato.",
			create_container: "{name} ha aggiunto un container.",
			delete_attachment: "{name} ha eliminato un allegato.",
			delete_container: "{name} ha eliminato un container.",
			update: "Aggiornato da {name}.",
			update_attachment: "{name} ha aggiornato un allegato.",
			update_container: "{name} ha aggiornato un container.",
		},
		$containerStatus: {
			arrived: "Arrivato",
			off_load: "Scaricamento",
			on_load: "Caricamento",
			on_way: "In transito",
			reserved: "Riservato",
		},
		$method: {
			aerial: "Aereo",
			land: "Terra",
			railway: "Ferrovia",
			sea: "Mare",
		},
		$vehicle: {
			license_number: "Targa",
		},
		archiving_success_message: "La spedizione è stata archiviata.",
		leave_message: "Lascia il tuo messaggio o commento",
		no_booking_info:
			"Nessuna informazione di prenotazione è stata ancora impostata. Usa il pulsante {0} per aggiungere.",
		no_transportation_info:
			"Nessuna informazione dettagliata è stata ancora impostata. Usa il pulsante {0} per impostare.",
		un_archiving_success_message: "La spedizione è stata disarchiviata.",
	},
	$shortening: {
		number: "N°",
	},
	$socialMedia: {
		facebook: "Facebook",
		instagram: "Instagram",
		linked_in: "LinkedIn",
		twitter: "Twitter",
	},
	$subscription: {
		$message: {
			check_your_payment_method: "Il tuo abbonamento non è stato rinnovato. Verifica il tuo metodo di pagamento.",
			fail: "Si è verificato un errore imprevisto. Riprova più tardi. Se il problema persiste, segnalalo inviando un'e-mail a info@antrego.net.",
			ok: "Il processo di acquisto è stato avviato. Il risultato del processo verrà notificato via e-mail. Il tuo abbonamento inizierà quando il pagamento sarà completato con successo.",
			payment_process_is_ongoing:
				"Il tuo processo di pagamento è in corso. Il risultato del processo verrà notificato via e-mail. Il tuo abbonamento inizierà quando il pagamento sarà completato con successo.",
			success: "Il tuo abbonamento è stato creato con successo. Puoi iniziare a utilizzare Antrego facilmente.",
			try_to_get_paid_again: "La tua sottoscrizione è scaduta. Clicca qui per rinnovare.",
			unsubscribed: "Annullato l'abbonamento",
			you_dont_have_any_subscription:
				"Non hai alcun abbonamento. Scegli un pacchetto nella pagina dell'abbonamento e inizia a usarlo facilmente.",
			you_dont_have_any_subscription_text: "Scegli un piano per continuare.",
			you_dont_have_any_subscription_title: "Non hai nessun abbonamento attivo.",
		},
	},
	$unit: {
		acres: "Acri",
		boxes: "Scatole",
		centimeter: "Centimetro",
		cubic_meter: "Metro cubo",
		dozen: "Dozzine",
		feet: "Piedi",
		fluid_ounces: "Once fluide",
		gallons: "Galloni",
		gram: "Gramma",
		hectare: "Ettaro",
		inches: "Pollici",
		kilogram: "Chilogrammo",
		kilometer: "Chilometro",
		liter: "Litro",
		meter: "Metro",
		miles: "Miglia",
		milligram: "Milligrammo",
		milliliter: "Millilitro",
		millimeter: "Millimetro",
		ounces: "Once",
		pallets: "Pallet",
		pieces: "Pezzi",
		pounds: "Libbre",
		quarts: "Quarti",
		square_feet: "Piedi quadrati",
		square_inches: "Pollici quadrati",
		square_kilometer: "Chilometro quadrato",
		square_meter: "Metro quadrato",
		square_miles: "Miglia quadrate",
		square_yards: "Iarde quadrate",
		ton: "Tonnellate",
		yards: "Iarde",
	},
	$validation: {
		email: "Per favore inserisci un'e-mail valida",
		invalid: "{item} non valido",
		max_length: "{item} deve essere inferiore a {length} caratteri",
		min_length: "{item} deve essere superiore a {length} caratteri",
		must_length: "{item} deve essere {length} caratteri",
		only_number: "{item} dovrebbe essere un numero",
		password_repeat_warning: "La ripetizione della password non è uguale alla nuova password.",
		required: "{item} è richiesto",
		required_for_default_language: "{item} è richiesto per la lingua predefinita dell'azienda.",
		you_must_approve_distance_sales_agreement: "Devi approvare il Contratto di Vendita a Distanza",
	},
	about: "Informazioni",
	accept_invitation: "Accetta invito",
	accept_invitation_success_message: "Hai utilizzato l'invito con successo.",
	accessibility: "Accessibilità",
	actions: "Azioni",
	active: "Attivo",
	activities: "Attività",
	add: "Aggiungi",
	add_attribute: "Aggiungi Attributo",
	add_from_stock: "Aggiungi dallo stock",
	add_images: "Aggiungi Immagine",
	add_item: "Aggiungi {item}",
	add_manually: "Crea qui",
	add_new_employee: "Aggiungi nuovo dipendente",
	add_new_packaging: "Aggiungi nuovo imballaggio",
	add_new_product: "Aggiungi nuovo prodotto",
	add_new_stock: "Aggiungi Nuova Scorta",
	add_new_warehouse: "Aggiungi Nuovo Magazzino",
	add_stock_batch: "Aggiungi Lotto di Scorte",
	add_template: "Aggiungi Modello",
	add_variant: "Aggiungi Variante",
	address: "Indirizzo",
	again: "Di nuovo",
	alert: "Avviso",
	already_have_employee_message: "Sei già un dipendente di un'azienda.",
	amount: "Importo",
	approve: "Approva",
	archive: "Archivia",
	attachment: "Allegato",
	attachments: "Allegati",
	attribute: "Attributo",
	attributes: "Attributi",
	auto_attached_pdf: "PDF aggiunto automaticamente",
	auto_detect: "Rilevamento automatico",
	available: "Disponibile",
	bank: "Banca",
	basket: "Carrello",
	basket_empty: "Il tuo carrello è vuoto",
	batch: "Lotto",
	batch_no: "Numero Lotto",
	batches: "Lotti Di Scorte",
	benefits: "Vantaggi",
	billed_to: "Fatturato a",
	booking: "Prenotazione",
	booking_code: "Codice di prenotazione",
	booking_details: "Dettagli della prenotazione",
	boolean: "Booleano",
	business_partner: "Partner commerciale",
	business_partners: "Partner commerciali",
	cancel: "Annulla",
	carrier: "Corriere",
	change_password: "Cambia password",
	checking_invitation_code_message: "Verifica del codice di invito",
	checkout: "Cassa",
	choose_image: "Scegli immagine",
	choose_your_plan: "Scegli il tuo piano",
	clear: "Pulisci",
	clear_basket: "Svuota Carrello",
	click_to_play_the_video: "Clicca per riprodurre il video",
	close: "Chiudi",
	code: "Codice",
	commercial: "Commerciale",
	commercial_partner: "Partner commerciale",
	commercial_partners: "Partner commerciali",
	companies: "Aziende",
	company: "Azienda",
	company_address: "Indirizzo della società",
	company_name: "Nome della società",
	company_profile: "Profilo aziendale",
	configuration: "Configurazione",
	confirm: "Conferma",
	confirm_distance_selling_agreement: "Conferma il Contratto di Vendita a Distanza.",
	consult_us: "Consultaci",
	contact: "Contatto",
	contact_info: "Informazioni di contatto",
	contact_text: "Stai certo, ti contatteremo il prima possibile.",
	contact_title: "Consultaci, semplifica i tuoi processi",
	contact_to_us: "Contattaci",
	container: "Container",
	container_no: "N. Contenitore",
	containers: "Container",
	content: "Contenuto",
	contract: "Contratto",
	copy_link: "Copia link",
	corporation: "Azienda",
	countries: "Paesi",
	country: "Paese",
	create: "Crea",
	create_a_new_account: "Crea un nuovo account",
	create_company: "Crea azienda",
	create_document: "Crea Documento",
	create_shipment: "Crea spedizione",
	created_at: "Creato il",
	created_here: "Creato qui",
	credit_card_info: "Informazioni sulla carta di credito",
	credit_card_no: "Numero della carta di credito",
	currencies: "Valute",
	currency: "Valuta",
	current_password: "Password attuale",
	current_plan: "Piano attuale",
	customer_company_address: "Indirizzo della società cliente",
	customer_company_name: "Nome della società cliente",
	customs: "Dogana",
	customs_agencies: "Agenzie doganali",
	customs_agency: "Agenzia doganale",
	cvv: "CVV",
	daily: "Giornaliero",
	damaged: "Danneggiato",
	dashboard: "Dashboard",
	date: "Data",
	date_input: "Campo data",
	day: "Giorno",
	default: "Predefinito",
	default_language: "Lingua predefinita",
	delete: "Elimina",
	delete_account: "Elimina account",
	delete_confirm_message: "Confermi l'eliminazione?",
	delete_document: "Elimina documento",
	delete_template: "Elimina modello",
	description: "Descrizione",
	detail: "Dettaglio",
	dimensions: "Dimensioni",
	discard: "Scarta",
	discover_all_benefits: "Scopri tutti i vantaggi",
	distance_sales_agreement: "Contratto di Vendita a Distanza",
	document: "Documento",
	document_actions: "Azioni documento",
	document_added: "Documento aggiunto",
	document_creator: "Generatore di documenti",
	document_manager: "Gestore documenti",
	document_name: "Nome del documento",
	document_number: "Numero documento",
	document_overwrite: "Salva modifiche come nuovo documento",
	document_save_info: "Questo documento sarà salvato solo all'interno di questa fattura proforma.",
	document_updated: "Documento aggiornato",
	download: "Scarica",
	download_pdf: "Scarica PDF",
	download_template: "Scarica il modello",
	edit: "Modifica",
	edit_attribute: "Modifica attributo",
	edit_description: "Modifica descrizione",
	edit_document: "Modifica documento",
	edit_item: "Modifica {item}",
	edit_packaging: "Modifica imballaggio",
	edit_product: "Modifica prodotto",
	edit_profile: "Modifica profilo",
	edit_stock: "Modifica stock",
	edit_stock_batch: "Modifica Lotto di Scorte",
	edit_template: "Modifica modello",
	edit_variant: "Modifica Variante",
	edit_your_profile_picture: "Modifica la tua immagine del profilo",
	email: "E-mail",
	employee: "Dipendente",
	employee_type: "Tipo di dipendente",
	employees: "Dipendenti",
	empty_data_warning:
		"In quest'area non ci sono ancora dati. Puoi iniziare a esplorare la piattaforma con dati di esempio.",
	estimated_arrival_day: "Giorno di arrivo stimato",
	expense: "Spesa",
	expenses: "Spese",
	expires_at: "Scade il",
	explore_pdf_editor: "Crea documenti all’istante",
	explore_stock_management: "Gestisci il tuo inventario",
	explore_tracking_features: "Traccia in tempo reale",
	exported_containers: "Container esportati",
	fail: "Fallito",
	failed: "Fallito",
	faq: "FAQ",
	feedback: "Feedback",
	file: "File",
	file_name: "Nome del File",
	file_preview: "Anteprima file",
	file_processing_error_message: "Errore durante l'elaborazione del file: {error}",
	file_read_error_message: "Errore nella lettura del file",
	file_view: "Visualizza file",
	filter: "Filtro",
	first_name: "Nome",
	first_name_last_name: "Nome Cognome",
	fixed_value: "Valore fisso",
	forget_password: "Hai dimenticato la password",
	forget_password_message: "Hai dimenticato la tua password?",
	forget_password_subtitle: "Inserisci il tuo indirizzo email per reimpostare la password.",
	format: "Formato",
	free: "Gratuito",
	from: "Da",
	general: "Predefinito",
	get_started_now: "Inizia ora",
	give_us_feedback: "Dacci un feedback",
	go_to_panel: "Vai al pannello",
	go_to_proforma: "Vai alla proforma",
	go_to_shipment: "Vai alla spedizione",
	gross: "Lordo",
	height: "Altezza",
	hide: "Nascondi",
	hide_all: "Nascondi Tutto",
	home_page: "Home Page",
	i_have_invitation_code: "Ho un codice di invito",
	image_delete: "Elimina immagine",
	images: "Immagini",
	import_excel: "Importa da Excel",
	import_fail_message: "Importazione fallita: {error}",
	import_success_message: "Importazione riuscita di {count} prodotti{skipped}.",
	imported_containers: "Container importati",
	in_progress: "In corso",
	in_stock: "Disponibile",
	incoming: "In arrivo",
	incoming_shipments: "Spedizioni in arrivo",
	initial: "Iniziale",
	inputs: "Contenuto",
	invitation: "Invito",
	invitation_code: "Codice invito",
	invitation_mail_sent: "E-mail di invito inviata",
	invitations: "Inviti",
	invoice: "Fattura",
	invoice_no: "Numero della fattura",
	join: "Unisci",
	join_company: "Unisciti all'azienda",
	language: "Lingua",
	language_options: "Opzioni di lingua",
	last_name: "Cognome",
	last_one_year: "Ultimo anno",
	latitude: "Latitudine",
	learn_more: "Scopri di più",
	left_a_comment: "Ha lasciato un commento",
	length: "Lunghezza",
	link_copied: "Link copiato",
	link_copy_failed: " Copia del link fallita",
	loading_country: "Paese di caricamento",
	loading_point: "Punto di caricamento",
	loading_port: "Porto di caricamento",
	log_in: "accedi",
	logo: "Logo",
	longitude: "Longitudine",
	lot_no: "Numero Lotto",
	mail_sent: "E-mail inviata",
	make_visible: "Rendi Visibile",
	manage_profile: "Gestisci profilo",
	mass: "Massa",
	measurements: "Misure",
	merge_partner_description:
		"L'azienda creata qui può essere unita al partner verificato esistente quando crea un profilo su Antrego.",
	message: "Messaggio",
	message_company_create: "Azienda creata.",
	message_company_join: "Inserisci il codice di invito.",
	message_company_joined: "Ti sei unito all'azienda",
	message_employee_delete: "Dipendente eliminato.",
	message_employee_save: "Dipendente salvato.",
	message_join_company: "Inserisci il tuo codice per unirti a un'azienda esistente",
	method: "Metodo",
	migrate: "Migra",
	migrate_partner: "Migra azienda",
	migrate_partner_description:
		"L'azienda creata qui può essere fusa con il partner verificato esistente quando crea un profilo su Antrego",
	missing_product_group_sheet_message: "Foglio Gruppo di Prodotti mancante nel file Excel",
	missing_product_sheet_message: "Foglio Prodotto mancante nel file Excel",
	mobile_number: "Numero di cellulare",
	month: "Mese",
	month_lowercase: "mese",
	monthly: "Mensile",
	multiple_select: "Selezione Multipla",
	my_profile: "il mio profilo",
	my_role: "Il mio ruolo",
	name: "Nome",
	net: "Netto",
	new: "Nuovo",
	new_company_package: "gratis",
	new_password: "Nuova password",
	new_shipment: "Nuova spedizione",
	next: "Prossimo",
	no: "No",
	no_content: "Nessun contenuto",
	no_entity: "Nessuna entità",
	no_entity_message: "Nessuna entità trovata.",
	no_image: "Immagine non trovata",
	no_product_data_message: "Nessun dato prodotto trovato nel file Excel",
	no_product_group_data_message: "Nessun dato del gruppo di prodotti trovato nel file Excel",
	no_stock_batches_found: "Nessun lotto di magazzino trovato",
	no_stock_matches_filters: "Non ci sono scorte che corrispondano ai filtri selezionati.",
	no_stocks_added_yet: "Non sono ancora state aggiunte scorte — seleziona o aggiungine una.",
	no_text: "Nessun testo",
	no_valid_products_message:
		"Nessun prodotto valido trovato. Tutti i prodotti devono avere un nome nella lingua predefinita ({language}).",
	not_found_in_stock: "Nessun prodotto trovato in magazzino con i filtri attuali.",
	not_found_page_message: "Scusa, non ho trovato questa pagina :(",
	not_set: "Non impostato",
	note: "Nota",
	notes: "Note",
	number_of_rows: "Numero di righe",
	ok: "OK",
	operation_fail: "Operazione fallita",
	option: "Opzione",
	options: "Opzioni",
	other: "Altro",
	out_of_stock: "Non Disponibile",
	outgoing: "In uscita",
	outgoing_shipments: "Spedizioni in uscita",
	packages: "Pacchetti",
	packaging: "Imballaggio",
	packing_list_title: "Lista di imballaggio",
	parent_group: "Gruppo padre",
	partner: "Partner",
	partners: "Partner",
	partnership_status: "Stato della partnership",
	passive: "Passivo",
	password: "Password",
	pay: "Paga",
	payback: "Rimborso",
	payback_confirm_message: "Confermi il rimborso?",
	payback_warning_message: "Se continui, il tuo abbonamento sarà terminato.",
	payment: "Pagamento",
	payment_amount: "Importo del pagamento",
	payment_awaited: "Pagamento in attesa",
	payment_history: "Storico dei pagamenti",
	payment_info: "Informazioni di pagamento",
	payment_information: "Informazioni di pagamento",
	payment_success: "Pagamento effettuato con successo",
	payment_summary: "Riepilogo del pagamento",
	payment_will_be_made_3d_secure: "*Il pagamento verrà effettuato con 3D Secure.",
	pdf_attached_message: "PDF aggiunto con successo",
	pdf_editor: "Editor PDF",
	pdf_name: "Nome PDF",
	pending_invitations: "Inviti in sospeso",
	per_month: "Al mese",
	phone_number: "Numero di telefono",
	pieces: "Pezzi",
	plate_numbers: "Numeri di targa",
	please_click_add_option: "Hai digitato un’opzione ma non l’hai aggiunta. Per favore aggiungila o eliminala.",
	prefix: "Prefisso",
	premium: "Premium",
	premium_plus: "Premium Plus",
	preview: "Anteprima",
	previous: "Precedente",
	price: "Prezzo",
	pricing: "Prezzi",
	process: "Processo",
	product: "Prodotto",
	product_details: "Dettagli del Prodotto",
	product_group: "Gruppo di prodotti",
	product_group_name: "Nome del gruppo di prodotti",
	product_group_not_found_message: 'Gruppo di prodotti "{group}" non trovato. Salto del prodotto con codice "{code}".',
	product_groups: "Gruppi di prodotti",
	product_images: "Immagini prodotto",
	product_name: "Nome del prodotto",
	products: "Prodotti",
	profile: "Profilo",
	proforma_invoice: "Fattura proforma",
	proforma_invoices: "Fatture proforma",
	proforma_number: "Numero proforma",
	proforma_options: "Opzioni Proforma",
	proforma_title: "Fattura proforma",
	purchase: "Acquisto",
	quantity: "Quantità",
	quantity_warning:
		"Poiché hai già modificato il valore del Totale Magazzino, il totale non sarà calcolato automaticamente.",
	ready_to_import: "Pronto per l'importazione",
	receiver: "Destinatario",
	receiver_company: "Azienda destinataria",
	receiver_customs_agency: "Agenzia doganale destinataria",
	redirection_to_home_link: "Home",
	redirection_to_home_message: "Puoi anche andare a ",
	redirection_to_sign_in_message: "Hai già un account?",
	redirection_to_sign_up_message: "Non hai ancora un account?",
	reload: "Ricarica",
	renewal: "Rinnovo",
	repaid: "Rimborsato",
	reserved: "Riservato",
	reset_password: "Reimposta password",
	returned: "Reso",
	route: "Percorso",
	rows_per_page: "Righe per pagina",
	sales: "Vendite",
	save: "Salva",
	save_as_document: "Salva come Documento",
	save_as_new_document: "Salva come Nuovo Documento",
	save_as_new_template: "Salva come Nuovo Modello",
	save_as_template: "Salva come Modello",
	save_changes: "Salva modifiche",
	save_pdf_to_attachments: "Salva PDF negli Allegati",
	saved_card_info: "Informazioni carta salvate",
	search: "Cerca",
	select: "Seleziona",
	select_a_file_to_preview: "Seleziona un file da visualizzare",
	select_document: "Seleziona il documento",
	select_document_to_overwrite: "Seleziona Documento da Sovrascrivere",
	select_file: "Seleziona file",
	select_file_place_holder: "Seleziona un'immagine",
	select_language: "Seleziona lingua",
	select_template: "Seleziona il modello",
	select_template_to_overwrite: "Seleziona Modello da Sovrascrivere",
	selected: "Selezionato",
	selected_partner: "Partner selezionato",
	send: "Invia",
	send_again: "Invia di nuovo",
	send_email: "Invia e-mail",
	send_feedback: "Invia feedback",
	send_invitation: "Invia invito",
	sender: "Mittente",
	sender_company: "Azienda mittente",
	sender_customs_agency: "Agenzia doganale mittente",
	separate_gross: "Aggiungi misurazioni lorde",
	settings: "Impostazioni",
	shipment: "Spedizione",
	shipment_code: "Codice spedizione",
	shipment_details: "Dettagli della spedizione",
	shipment_method: "Metodo di spedizione",
	shipment_type: "Tipo di spedizione",
	shipments: "Spedizioni",
	shipments_filter: "Filtro spedizioni",
	shipped: "Spedito",
	shipping_term: "Termine di spedizione",
	shipping_terms: "Termini di spedizione",
	show: "Mostra",
	show_all: "Mostra Tutto",
	show_company_stock_page: "Mostra Pagina Scorte Aziendali",
	show_in_stocks: "Mostra nella Pagina Magazzino",
	sign_in: "Accedi",
	sign_out: "Esci",
	sign_out_confirm_message: "Confermi l'uscita?",
	sign_out_success_message: "Arrivederci.",
	sign_up: "Registrati",
	sizes: "Dimensioni",
	social_media: "Social Media",
	social_media_account: "Account social media",
	start_time: "Ora di inizio",
	status: "Stato",
	stock: "Magazzino",
	stock_details: "Dettagli della Scorta",
	stock_feature: "Software di gestione dell'inventario | Sistema di tracciamento delle scorte | Antrego",
	stock_images: "Immagini di Scorte",
	stock_status: "Stato Della Scorta",
	stocks: "Scorte",
	stocks_url: "Link Magazzino",
	subscribe: "Abbonati",
	subscription: "Abbonamento",
	subscription_info_message: "Puoi usufruire di tutti i servizi in modo illimitato durante il periodo di abbonamento.",
	subscription_warning_message:
		"**Le informazioni sulla tua carta saranno memorizzate in modo sicuro e il tuo abbonamento verrà rinnovato regolarmente a meno che non lo annulli.",
	success: "Successo",
	super: "Super",
	supported_files_img: "File supportati: JPG, PNG.",
	switch_language: "Cambia lingua",
	switch_theme: "Cambia tema",
	table_inputs: "Contenuto della tabella",
	target: "Obiettivo",
	target_partner: "Partner obiettivo",
	tax_number: "Numero fiscale",
	template: "Modello",
	template_actions: "Azioni modello",
	template_added: "Modello aggiunto",
	template_name: "Nome del Modello",
	template_overwrite: "Salva modifiche come nuovo modello",
	template_save_info: "I modelli salvati saranno disponibili in seguito per l'uso in fatture proforma e spedizioni.",
	template_updated: "Modello aggiornato",
	terms_of_sale_and_other_comments: "Termini di vendita - Commenti",
	text_input: "Campo di testo",
	theme: "Tema",
	this_month: "Questo mese",
	this_year: "Quest'anno",
	title: "Titolo",
	to: "A",
	toDelete: "Elimina",
	total: "Totale",
	total_amount: "Importo totale",
	total_price: "Prezzo Totale",
	total_warning: "Se modifichi questi dati, il totale non sarà più calcolato automaticamente.",
	tracking: "Tracciamento delle spedizioni",
	transaction_no: "Numero transazione",
	transactions: "Transazioni",
	try_for_free: "prova gratis",
	type: "Tipo",
	types: "Tipi",
	un_archive: "Disarchivia",
	unit: "Unità",
	unit_price: "Prezzo unitario",
	units: "Unità",
	unloading_country: "Paese di scarico",
	unloading_point: "Punto di scarico",
	unloading_port: "Porto di scarico",
	unsubscribe: "Annulla l'abbonamento",
	unsubscribe_confirm_message:
		"Se annulli l'abbonamento, non sarai in grado di utilizzare efficacemente le funzionalità del sistema. Sei sicuro di voler annullare l'abbonamento?",
	upload_new_image: "Carica nuova immagine",
	use_code: "Usa codice",
	use_invitation_code: "Usa codice invito",
	use_invitation_code_description: "Digita il tuo codice di invito inviato alla tua casella di posta.",
	use_invitation_code_success_message: "Il codice di invito è stato utilizzato con successo.",
	user_profile: "Il mio profilo",
	value: "Valore",
	variant: "Variante",
	variants: "Varianti",
	vehicle: "Veicolo",
	vehicles: "Veicoli",
	verified_partner: "Partner verificato",
	verify_password: "Verifica password",
	visibility: "Visibilità",
	warehouse: "Magazzino",
	warehouses: "Magazzini",
	warn_unsaved_measurement: "Non dimenticare di cliccare ‘+’ per aggiungere le tue misure.",
	website: "Sito web",
	week: "Settimana",
	weight: "Peso",
	weight_kg: "Peso (kg)",
	welcome: "Benvenuto",
	what_we_are_doing: "Cosa stiamo facendo",
	width: "Larghezza",
	year: "Anno",
	year_lowercase: "anno",
	yearly: "Annuale",
	yes: "Sì",
	yes_no: "Sì / No",
	you_dont_have_any_active_subscription: "Non hai alcun abbonamento attivo.",
};
